import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { EXCLUDE_FROM_DB_REASON } from '../../config/const.config';

const ExcludeFromDBReason = ({
  id,
  name,
  defaultValue,
  label,
  onChange,
  disabled,
  sx,
  error,
}) => (
  <FormControl fullWidth error={error !== ''} variant="filled">
    <InputLabel id={`field-${id}-select-label`}>{label}</InputLabel>
    <Select
      labelId="demo-simple-select-label"
      id={id}
      name={name}
      value={defaultValue}
      label={label}
      onChange={onChange}
      disabled={disabled}
      sx={sx}
    >
      <MenuItem value="null">----------</MenuItem>
      {Object.keys(EXCLUDE_FROM_DB_REASON).map((k) => (
        <MenuItem key={`${id}-v-${k}`} value={k}>
          {EXCLUDE_FROM_DB_REASON[k]}
        </MenuItem>
      ))}
    </Select>
    {error !== '' && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);

ExcludeFromDBReason.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  sx: PropTypes.shape(),
  error: PropTypes.string,
};
ExcludeFromDBReason.defaultProps = {
  disabled: false,
  sx: {},
  error: '',
};

export default ExcludeFromDBReason;
